// extracted by mini-css-extract-plugin
module.exports = {"gallery":"Gallery_gallery__H74xe","galleryClosed":"Gallery_galleryClosed__1sG_m Gallery_gallery__H74xe","galleryImg":"Gallery_galleryImg__2aTq0","caption":"Gallery_caption__3lbNF"};